var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", { staticClass: "text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-success btn-xs",
                attrs: { type: "button" },
                on: { click: _vm.getTaksks },
              },
              [_vm._v("Обновить задачи")]
            ),
          ]),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? [
                !_vm.tasks || !_vm.tasks.length
                  ? [_vm._m(0)]
                  : [
                      _c("div", [
                        _c(
                          "table",
                          { staticClass: "table table-sm table-hover" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.tasks, function (task, i) {
                                return _c("tr", { key: task.id }, [
                                  _c("td", [
                                    _vm._v(_vm._s(i + 1) + " "),
                                    _c("span", { staticClass: "text-muted" }, [
                                      _vm._v("(" + _vm._s(task.id) + ")"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(task.object_id))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("span", {
                                      class: `priority priority-${
                                        (task.drug && task.drug.priority) || 0
                                      }`,
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(task.drug && task.drug.title) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "strong",
                                      _vm._l(
                                        task.task_data.selected_projects,
                                        function (projectId, i) {
                                          return _c("span", [
                                            _vm._v(
                                              _vm._s(i !== 0 ? ", " : "") +
                                                _vm._s(
                                                  _vm.$AllProjects[projectId]
                                                    .title
                                                )
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-outline-success",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openTask(task.id)
                                          },
                                        },
                                      },
                                      [_vm._v("Создать")]
                                    ),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ],
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [_vm._v("На данный момент нет активных задач на создание")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Проекты")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }